import React from "react";
import { Controller, useFormContext, useWatch } from "react-hook-form";
import { TextField } from "../../../../components/forms/text";
import { Toggle } from "../../../../components/forms/toggle";
import { Grid } from "../../../../components/layout";
import { FieldSubSection, SectionTitle } from "../common/components";
import { InnerFormType } from "./common";

export const ConsentNote: React.FunctionComponent<{}> = () => {
  const { control, watch } = useFormContext<InnerFormType>();

  const faceAttachmentRequired = useWatch<InnerFormType>({
    control,
    name: "faceAttachmentRequired",
  });

  const askForConsentNote = useWatch<InnerFormType>({
    control,
    name: "askForConsentNote",
  });

  return (
    <>
      <SectionTitle>Facial Confirmation</SectionTitle>
      <FieldSubSection>
        <Grid col-xs={2} alignItems="center">
          <strong>Require Photo</strong>
          <Controller
            control={control}
            name="faceAttachmentRequired"
            defaultValue={false}
            render={({ field, fieldState: { error } }) => (
              <Toggle {...field} error={!!error} helperText={error?.message} />
            )}
          />
          <strong>Ask for Consent Note</strong>
          <Controller
            control={control}
            name="askForConsentNote"
            defaultValue={false}
            render={({ field, fieldState: { error } }) => (
              <Toggle
                disabled={!faceAttachmentRequired}
                {...field}
                error={!!error}
              />
            )}
          />
          <strong>Consent Note Text</strong>
          <Controller
            control={control}
            name="consentNote"
            defaultValue=""
            render={({ field, fieldState: { error } }) => (
              <div style={{ flexGrow: 1, marginLeft: "1em" }}>
                <TextField
                  disabled={!askForConsentNote}
                  fullWidth
                  placeholder="Welcome to 2023"
                  {...field}
                  error={!!error}
                  helperText={error?.message}
                />
              </div>
            )}
          />
        </Grid>
      </FieldSubSection>
    </>
  );
};
